var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUsersThree = function SvgIconUsersThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.13 5.892a2 2 0 0 1 .744 3.921 1 1 0 0 0-.678 1.337 1 1 0 0 0 .833.771 4.63 4.63 0 0 1 3.046 1.804 1 1 0 0 0 1.6-1.2 6.6 6.6 0 0 0-2.346-1.955 3.999 3.999 0 1 0-6.565-4.42 1 1 0 0 0 1.804.863 2 2 0 0 1 1.562-1.12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 8.375a4.75 4.75 0 0 0-3.19 8.27 7 7 0 0 0-3.109 3.166 1 1 0 1 0 1.797.878 5.01 5.01 0 0 1 9.003 0 1 1 0 1 0 1.797-.878 7 7 0 0 0-3.109-3.166A4.75 4.75 0 0 0 12 8.375m-2.75 4.75a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87 5.892a2 2 0 0 0-.744 3.921 1 1 0 0 1 .678 1.34 1 1 0 0 1-.833.768 4.63 4.63 0 0 0-3.046 1.804 1 1 0 0 1-1.6-1.2 6.6 6.6 0 0 1 2.346-1.955 4 4 0 1 1 6.565-4.42 1 1 0 0 1-1.803.863 2 2 0 0 0-1.562-1.12"
  }))));
};
export default SvgIconUsersThree;